<template>
	<div v-if="currentUser" id="app_dc" :class="routename">
		<header-bar class="d-print-none" :show="true"></header-bar>
		<app-main></app-main>
		<footer-bar class="d-print-none"></footer-bar>
	</div>
</template>

<script>
import HeaderBar from "./HeaderBar";
import AppMain from "./AppMain";
import FooterBar from "./FooterBar";

export default {
	name: "SuperAdminLayout",
	components: {
		HeaderBar,
		AppMain,
		FooterBar
	},
	computed: {
		routename() {
			const routename = this.$route.path
				.replace(/\d/g, "")
				.split("/")
				.filter((name) => name)
				.join("-");
			return `gtm-${routename}`;
		}
	}
};
</script>

<style lang="scss">
html,
body,
#app_dc {
	height: 100%;
}
</style>
